import PropTypes from 'prop-types';
import React from 'react';
import { View, StyleSheet } from 'react-native';

function getStyles() {
  return StyleSheet.create({
    contentFrame: {
      overflow: 'hidden',
    },
  });
}

const FrameContent = props => {
  const styles = getStyles();
  return <View {...props} style={[styles.contentFrame, props.style]} />;
};

FrameContent.propTypes = {
  style: PropTypes.any,
};

export default FrameContent;
